import { useAuthMutation } from 'features/common/apiUtils/queryHelper';
import { groupsApiConfig } from './config';
import { AddGroupMembersPayload } from './types';
import { UseMutationOptions, useQueryClient } from 'react-query';
import { AxiosResponse } from 'axios';

const {
  add_delete_group_members: { url, scope },
  get_group_members: { queryKey },
} = groupsApiConfig;

export const useAddGroupMembers = (
  mutationOptions?: Omit<
    UseMutationOptions<
      AxiosResponse,
      unknown,
      AddGroupMembersPayload & { groupId: string },
      unknown
    >,
    'mutationFn'
  >,
) => {
  const queryClient = useQueryClient();
  return useAuthMutation(
    (axiosInstance) =>
      async (payload: AddGroupMembersPayload & { groupId: string }) => {
        await axiosInstance?.post(url(payload.groupId), {
          members: payload.members,
        });
      },
    {
      onSuccess: async () => {
        setTimeout(async () => {
          mutationOptions ??
            (await queryClient.invalidateQueries([...queryKey]));
        }, 1000); // delay refetch for proper UI update
      },
    },
    scope,
  );
};
